var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardDecor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 132,
    viewBox: "0 0 132 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68 32C68 14.3269 82.3269 0 100 0H132V32C132 49.6731 117.673 64 100 64H68V32Z",
    fill: "#F4A261"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 64C14.3269 64 0 49.6731 0 32L0 0H32C49.6731 0 64 14.3269 64 32V64H32Z",
    fill: "#F4A261"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M100 132C82.3269 132 68 117.673 68 100V68H100C117.673 68 132 82.3269 132 100V132H100Z",
    fill: "#F4A261"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardDecor);
export default __webpack_public_path__ + "static/media/card_decor.f024dad1399e819844925e627b764f8e.svg";
export { ForwardRef as ReactComponent };